module.exports = __webpack_public_path__ + "static/media/employee-details.82761e26.png";